/* eslint-disable no-prototype-builtins */
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Image from 'components/common/Image';
import imageResize from 'utils/imageResize';
import {
  Player,
  ControlBar,
  BigPlayButton,
  PlayToggle,
  LoadingSpinner,
} from 'video-react';
import 'node_modules/video-react/dist/video-react.css';

import getMaxString from 'utils/getMaxString';
import { ScrollToLoad } from 'components';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { IImageSlider } from './IImageSliderFeed';
import {
  ArrowNext,
  ArrowPrev,
  CarouselDots,
  CoverImg,
  ImageSliderWrapper,
  ImageWrap,
  WheelMarkIconWrap,
} from './ImageSliderFeed.styles';

const getVideoWidthHeight = (daimention) => {
  const wid = daimention?.width;
  const hit = daimention?.height;
  let aspect = wid / 550;
  return {
    width: 550,
    height: hit / aspect,
  };
};

const ImageSlider = ({
  images,
  alt = 'photo post image',
  variantToUse = '_detail',
}: IImageSlider) => {
  const getPostImagesHeight = (width, height) => {
    const imageWidth = 550;
    const aspectRatio = width / height;
    const h = (imageWidth / width) * height;
    if (aspectRatio >= 3) {
      return imageWidth / 3;
    }
    if (aspectRatio <= 0.66666) {
      return imageWidth * 1.5;
    }
    return h;
  };

  return (
    <ImageSliderWrapper length={images?.length}>
      <ScrollToLoad
        pageSize={DEFAULT_PAGE_SIZE}
        loader={<div />}
        totalData={images?.length}
        isResetOffset={false}
        isMore={false}
        data={images}
        fetchMoreData={() => {}}
        render={(el, i) => {
          if (el?.dimensions) {
            return (
              <ImageWrap
                height={
                  getPostImagesHeight(
                    el?.dimensions?.width,
                    el?.dimensions?.height
                  ) || 366
                }
                key={`media-${i}`}
              >
                {!el?.videoUrl ? (
                  <Image
                    src={
                      imageResize(el?.url, variantToUse) ||
                      el?.url ||
                      '/assets/img/tireTrace.png'
                    }
                    unoptimized
                    priority
                    alt={getMaxString(alt, 8)}
                    width={550}
                    height={
                      getPostImagesHeight(
                        el?.dimensions?.width || 515,
                        el?.dimensions?.height || 366
                      ) || 366
                    }
                  />
                ) : (
                  <Player
                    autoPlay={false}
                    controls={false}
                    width={550}
                    height={getVideoWidthHeight(el?.dimensions)?.height}
                    fluid={false}
                    poster={el?.url}
                    // src={el?.videoUrl}
                  >
                    <source src={el?.videoUrl} />
                    <LoadingSpinner />
                    <BigPlayButton position="center" />
                    <ControlBar autoHide disableDefaultControls>
                      <PlayToggle />
                    </ControlBar>
                  </Player>
                )}
              </ImageWrap>
            );
          }
        }}
      />
    </ImageSliderWrapper>
  );
};
export default ImageSlider;
